import React from "react";
import "./App.css";
import "./index.css";
import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About_Us from "./components/about-us/About_Us";
import Services from "./components/services/Services";
import Service_Inner_Page from "./components/services/service-inner-page/Service_Inner_Page";
import Blogs from "./components/blogs/Blogs";
import Blog_Inner_Page from "./components/blogs/blog-inner-page/Blog_Inner_Page";
import Contact_us from "./components/contact-us/Contact.Us";
import Gallery from "./components/gallery/Gallery";
import GalleryInner from "./components/gallery/gallery-inner/Gallery_Inner";
import Faq from "./components/faq/Faq";
import Privacy_Policy from "./components/privacy-policy/Privacy_Policy";
import Terms_Of_Service from "./components/terms-of-service/Terms_Of_Service";
import ScrollToTop from "./components/scrolltotop/ScrollToTop";
import Subsidy_Policy from "./components/subsidy-policy/Subsidy_Policy";
import New_Highlight_Inner_Page from "./components/subsidy-policy/new-highlights/new-highlight-inner-page/New_Highlight_Inner_Page";
import WhatsAppButton from "./components/whatsAppButton/WhatsAppButton";

function App() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/subsidy-policy" element={<Subsidy_Policy />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:id" element={<Service_Inner_Page />} />
        <Route path="/blog" element={<Blogs />} />
        <Route path="/blog/:id" element={<Blog_Inner_Page />} />
        <Route path="/contact-us" element={<Contact_us />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/gallery-inner/:id" element={<GalleryInner />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/terms-of-services" element={<Terms_Of_Service />} />
        <Route
          path="/new-highlight-inner-page"
          element={<New_Highlight_Inner_Page />}
        />
      </Routes>
      <Footer />
       <WhatsAppButton/>
    </>
  );
}

export default App;
